
import template from './fields-table-list.html';

/**
 * This is an example knockout component class. Note the export section at the end of the file.
 * @kind component
 * @class SampleComponent
 * @description Sample Component that shows the name value
 */
class FieldsTableListViewModel
{
	constructor(params)
	{
		this.params = params;

		this.data = ko_helper.safe_observable(params.data);
		this.selectedFieldsTable = ko_helper.safe_observable(params.selectedFieldsTable);
		this.selected = ko.observable();

		this.records = ko.observableArray([]);

		this.table_fields = ko.observableArray([
			{
				name: 'display_name'
			},
			{
				name: 'schema'
			},
			{
				name: 'table'
			},
			{
				name: 'idx'
			},
			{
				name: 'options',
				formatter: 'json'
			}
		]);

		this.fields = ko.observableArray();
		this.visible_fields = ko.observableArray([]);
		this.visible_fields.subscribe(() => { this.update(); });

		this.filters = ko.observableArray([]);
		this.filters.subscribe(() => this.update());

		this.sortfield = ko.observable();
		this.sortorder = ko.observable('DESC');

		this.page_number = ko.observable();
		this.total_pages = ko.observable();

		this.init();
	}

	async init()
	{
		let options = {};
		if (window.localStorage.getItem('fields.fields-table.fields-table-list-options'))
			options = JSON.parse(window.localStorage.getItem('fields.fields-table.fields-table-list-options'));
		else
			options = {
				fields: ['display_name', 'schema', 'table', 'idx', 'options']
			};

			let list = [];
			for (let field of this.table_fields())
			{
				if (!field.name)
					continue;
				let newfield = {
					name: field.name,
					visible: ko.observable(options.fields.indexOf(field.name) < 0 ? false : true)
				};

				if (field.formatter)
				{
					if (field.formatter == 'json')
						newfield.formatter = x => JSON.stringify(x);
				}

				list.push(newfield);
			}
			this.fields(list);

			if (options.sortfield)
				this.sortfield(options.sortfield);
			if (options.sortorder)
				this.sortorder(options.sortorder);
			if (options.filter)
				this.filters(options.filter);
	}

	async update()
	{
		this.fetchFieldsTables();
	}

	async fetchFieldsTables()
	{
		let options = this.serializeOptions();
		let result = await Grape.fetches.getJSON('/api/record', options);
		if (result.status == 'OK')
		{
			this.records(result.records);
			this.page_number(result.page_number);
			this.total_pages(result.total_pages);
		}
		else
			Grape.alerts.alert({type: 'error', message: result.message || 'Fail' });
	}

	serializeOptions()
	{
		let fields = ['fields_table_uuid', 'schema', 'table', 'display_name', 'idx', 'options'];
		for (let f of this.fields())
			if (f.visible())
				fields.push(f.name);

		let filters = [];
		for (let f of this.filters())
			filters.push({field: f.field, operator: f.operator, value: f.value});

		let options = {
			schema: 'fields',
			table: 'fields_table',
			fields: fields,
			filter: filters
		};

		if (this.sortfield() && this.sortfield().length)
		{
			options.sortfield = this.sortfield();
			options.sortorder = this.sortorder();
		}

		window.localStorage.setItem('fields.fields-table.fields-table-list-options', JSON.stringify(options));

		return options;
	}

	async editFieldsTable(data, event)
	{
		let res = await Grape.dialog.open('AddEditFieldsTable', {fieldsTable:data, edit: true});

		if (res?.status === 'OK')
		{
			this.update();
			this.selectFieldsTable('');
		}
	}

	selectFieldsTable(data, event)
	{
		if (data === this.selected()) 
			this.selected(null);
		else 
			this.selected(data);

		this.selectedFieldsTable(data);
	}

	async btn_upsert_field_table()
	{
		let res = await Grape.dialog.open('AddEditFieldsTable', {fieldsTable:{}});
		if (res?.status === 'OK')
			this.update();
	}

	async deleteFieldsTable(data)
	{
		let confirm = await Grape.alerts.confirm({type:'warning', title:'Delete', message:`Delete Custom Fields Table <b>${data.display_name}( ${data.schema}.${data.table} )</b>? This may result in loss of data.`, cancel_type:'default', accept_type:'warning'});
		if (confirm)
		{
			let res = await Grape.fetches.deleteJSON('/api/custom-fields/table/delete', {fields_table_uuid:data.fields_table_uuid});
			if (res?.status === 'OK')
			{
				this.update();
				this.selectedFieldsTable('');
				return res;
			}

			Grape.alerts.apiError(res);
		}
	}
}

export default {
	name: 'fields-table-list',
	viewModel: FieldsTableListViewModel,
	module_type: 'ko',
	template: template
};
